<template>
  <div class="knows dj-container">
    <Row :gutter="16">
      <i-col :span="4">
        <ul class="l-s-n bg-white">
          <li :class="['item', index === idx && 'active']" @click="index = idx" v-for="(item, idx) in list" :key="item.id">{{ item.remark }}</li>
        </ul>
      </i-col>
      <i-col :span="20">
        <div class="bg-white html-container" v-html="html"></div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { makeSgin } from '@/utils/index'
export default {
  data() {
    return {
      list: [],
      index: 0
    }
  },
  computed: {
    html() {
      return this.list[this.index] ? this.list[this.index].paramValue : ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this._r.get('open/api/courseIntroduction?sign=' + makeSgin()).then(({code, data, msg}) => {
        if (code === 0) {
          this.list = data
        } else {
          this.$Message.error(msg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.knows {
  .item {
    padding: 0.6rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    &.active {
      background: var(--active-color);
      color: var(--main-font-color);
    }
  }
  .html-container {
    padding: 1rem 2rem;
    video {
      width: 100%;
    }
  }
}
</style>